import { Star } from "lucide-react";

export const Stars = ({ value = 5, size = "h-4 w-4" }) => (
  <div className="relative inline-flex shrink-0" dir="ltr" aria-label={`${value} من 5 نجوم`}>
    <div className="flex gap-0.5">
      {[...Array(5)].map((_, i) => (
        <Star key={i} className={`${size} text-slate-300`} fill="currentColor" strokeWidth={0} />
      ))}
    </div>
    <div className="absolute inset-0 overflow-hidden" style={{ width: `${Math.min(100, Math.max(0, (value / 5) * 100))}%` }}>
      <div className="flex gap-0.5">
        {[...Array(5)].map((_, i) => (
          <Star key={i} className={`${size} text-[#C80000]`} fill="currentColor" strokeWidth={0} />
        ))}
      </div>
    </div>
  </div>
);
